import React from 'react';
import { Table, Alert } from 'reactstrap';
import { TenantUsageEntry }  from './TenantUsageEntry'
import { Tenant } from 'logic/apiCalls';

import css from './TenantsUsageEntries.module.scss';

type TenantUsageEntriesProps = {
    tenants: Tenant[], 
    handleLineChart: (tenantToUpdate: Tenant) => void,
}

export const TenantUsageEntries = ({ tenants, handleLineChart } : TenantUsageEntriesProps) => {

    if (tenants.length === 0) {
        return <Alert color='warning'>
            No tenants are configured
        </Alert>
    }

    return (
        <div className={css.tenantTable}>
            <Table className="table-striped">
                <thead className="thead-dark">
                    <tr className="d-flex">
                        <th className="col-3">Id</th>                        
                        <th className="col-3">Name</th>
                        <th className="col-3">Azure Id</th>                        
                        <th className="col-3"></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        tenants.map((value) => {
                            return <TenantUsageEntry key={value.id} tenant={value} handleLineChart={handleLineChart}/>
                        })
                    }
                </tbody>
            </Table>
        </div>
    )
}